<template>
  <div>
    <v-row
      :class="index % 2 == 1 ? 'grey-box' : ''"
      v-for="(property, index) in properties"
      :key="index"
    >
      <v-col cols="12" md="4" sm="6">
        <b> {{ property.propertyTitle }}</b>
      </v-col>
      <v-col cols="12" md="8" sm="6">
        <span v-if="property.propertyType == 'MultiSelectList' && property.value.length>0">
          <!-- <span v-for="(prop, index) in property.value.split('|')" :key="index">
            {{ prop }}
            <span v-if="index < property.value.split('|').length - 2 && prop">
              -
            </span>
          </span> -->
          <!-- {{ property.value.length>0 ? property.value.replaceAll('|',' - ') : "" }} -->
             
        </span>
       
          <v-img v-if="property.propertyType == 'File'"
            class="  lighten-2 cursor-pointer"
            :src="
              property && property.fileValue
                ? property.fileValue.thumbnailFileUrl
                : ''
            "
            @click="
              openImage(property.fileValue ? property.fileValue.fileUrl : '')
            "
            max-width="50"
            max-height="50"
            contain
          />
          <v-tooltip bottom  v-if="property.propertyType == 'File'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  openImage(
                    property.fileValue ? property.fileValue.fileUrl : ''
                  )
                "
                class="text-gray-600 mr-3"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>
            </template>
            <span>دانلود</span>
          </v-tooltip>
       
        <span v-if="property.propertyType == 'Number'">
       {{
            property.maxValue
              ? `از:  ${property.value.replace('.','/').replace('-','منفی')}   تا: ${property.maxValue}`
              : property.value.replace('.','/').replace('-','منفی')
          }}
      
      </span>
        <span v-else>
     
         {{
       
              property.value=='true'? 'بلی':property.value=='false'? 'خیر':  property.value  
          }}
           
        </span>
        <span v-if="property.measurementUnitDisplayText">{{
          property.measurementUnitDisplayText
        }}</span>
        <!-- <span v-if="property.measurementUnitDisplayText">{{
          property.measurementUnitDisplayText
        }}</span> -->
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    properties: {
      type: Array,
      default: null,
    },
  },
  methods: {
    openImage(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.grey-box {
  background-color: #f3f6fb;
}
</style>